/**
 * Mega menu – dynamic image preview on hover
 *
 * When a user hovers over a menu link that has [data-mega-img],
 * the right-side preview image, title, and link update with a fade transition.
 */
(function () {
  'use strict';

  const FADE_CLASS = 'is-fading';
  const ACTIVE_CLASS = 'is-active';
  const FADE_DURATION = 200; // ms – matches CSS transition

  function initMegaMenu(megaNav) {
    const preview = megaNav.querySelector('.sub-nav__mega-preview');
    if (!preview) return;

    const previewLink = preview.querySelector('.sub-nav__mega-preview-link');
    const previewImg = preview.querySelector('.sub-nav__mega-preview-img img');
    const previewTitle = preview.querySelector('.sub-nav__mega-preview-title');
    const links = megaNav.querySelectorAll('.sub-nav__mega-links .sub-nav-item-link[data-mega-img]');

    if (!previewImg || links.length === 0) return;

    // Store defaults from first render
    const defaultSrc = previewImg.getAttribute('src') || '';
    const defaultAlt = previewImg.getAttribute('alt') || '';
    const defaultHref = previewLink ? previewLink.getAttribute('href') : '';
    const defaultTitle = previewTitle ? previewTitle.textContent : '';

    let currentSrc = defaultSrc;
    let hoverTimeout = null;

    function updatePreview(src, alt, href, title) {
      if (src === currentSrc) return;
      currentSrc = src;

      // Fade out
      previewImg.classList.add(FADE_CLASS);

      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        // Swap image
        previewImg.setAttribute('src', src);
        previewImg.setAttribute('alt', alt);

        // Update link
        if (previewLink) {
          previewLink.setAttribute('href', href);
        }

        // Update title
        if (previewTitle) {
          previewTitle.textContent = title;
        }

        // Fade in
        previewImg.classList.remove(FADE_CLASS);
      }, FADE_DURATION);
    }

    // Attach hover listeners
    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        const imgSrc = this.getAttribute('data-mega-img');
        const title = this.getAttribute('data-mega-title') || '';
        const href = this.getAttribute('data-mega-url') || this.getAttribute('href') || '';

        // Highlight active link
        links.forEach(function (l) { l.classList.remove(ACTIVE_CLASS); });
        this.classList.add(ACTIVE_CLASS);

        if (imgSrc) {
          updatePreview(imgSrc, title, href, title);
        }
      });
    });

    // Reset on mouse leave from the entire mega menu
    megaNav.addEventListener('mouseleave', function () {
      links.forEach(function (l) { l.classList.remove(ACTIVE_CLASS); });
      updatePreview(defaultSrc, defaultAlt, defaultHref, defaultTitle);
    });
  }

  // Initialize all mega menus on DOM ready
  function init() {
    const megas = document.querySelectorAll('[data-mega-menu]');
    megas.forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
